import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from './Pages/LoginPage';
import MenuPage from './Pages/MenuPage';
import NewGame from './Pages/NewGame';
import PlayerStats from './Pages/PlayerStats';
import TeamStats from './Pages/TeamStats';
import ManageTeam from './Pages/ManageTeam';
import RequestTeam from './Pages/RequestTeam';
import ApprovePlayerRequests from './Pages/ApprovePlayerRequests';
import AdminLogin from './Pages/AdminLogin';
import ReviewTeamRequests from './Pages/ReviewTeamRequests';
import AdminSettings from './Pages/AdminSettings';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/menu/:teamName" element={<MenuPage />} />
        <Route path="/new-game/:teamName" element={<NewGame />} />
        <Route path="/player-stats/:teamName" element={<PlayerStats />} />
        <Route path="/team-stats/:teamName" element={<TeamStats />} />
        <Route path="/manage-team/:teamName" element={<ManageTeam />} />
        <Route path="/approve-player-requests/:teamName" element={<ApprovePlayerRequests />} />
        <Route path="/request-team" element={<RequestTeam />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/review-team-requests" element={<ReviewTeamRequests />} />
        <Route path="/admin-settings" element={<AdminSettings />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
